import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../App"
import axios from "axios";
import { API_URL, getAuthHeaders } from "../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { isNumeric } from "../../../Custom/Custom";
import { downloadAsiListingExcelReport } from "../../../Custom/ASIReport/asiListingReportExcel";
import messages from '../../../assets/Messages.json';
import asiTitle from '../../../asi.json';
import asiInputTitle from '../../../titles.json';


function ListingReport() {

    const [year,setYear]=useState([]);  
    const [yearName, setYearName] = useState("");
    const [dslNo, setDslNo] = useState("");
    const token = useContext(MyContextProvider).token;
    const storedLanguage = localStorage.getItem('language');
    const config = getAuthHeaders();


useEffect(() => {
     getSurveyYears();
}, []);
          
        
//get Years 
const getSurveyYears=async()=>{
  showLoading(true)
     try {
        const response = await axios.get(`${API_URL}api/asi/surveyYearList`, config);
        const allYear = response.data;
        if (allYear.status) {
            setYear(allYear.data.surveyYearList.reverse())
            showLoading(false);
        }
  } catch (error) {
     console.error(error);
     showLoading(false);
  }finally{
     showLoading(false);
  }

}
       


// Handle on change Event ********
const handleDropdownChange=(e)=>{
    switch (e.target.name) {
      case "yearName":
      setYearName(e.target.value);
      break;
      case "dslNo":
        if(!isNumeric(e.target.value)){
           setDslNo('');
           return false;
       }
        setDslNo(e.target.value);
      break;
    default:
      console.log("switch case are not match");
      break;
  }
}


// Function to handle validate DSL text box filed
const validateDSL = (dslNumber) => {
   
  let dslNo=dslNumber.toString();
  if (!dslNo) {
        toast.error(messages.DSL_MAND_MSG, messages.COLOR_RED);
        return false;
  } else if (dslNo.length !== 6) {
        toast.error(messages.DSL_SIX_MSG, messages.COLOR_RED);
        return false;
  }  else {
     return true;
  }
}



 // Function to generate Excel file using mapped data
 const handleGenerateExcel = async () => {
        if (!validateDSL(dslNo)) {
          return false;
        }
      if (!yearName) {
        toast.error("Please select a Survey Year", messages.COLOR_RED);
        return;
      }

    try{
  
      let postData = {
          dslNo: dslNo,
          survey_year:yearName
        }
       showLoading(true);
       const response = await axios.post(`${API_URL}api/asi/reports/ListingReports/asiListingReport`, postData, config);
       const allData = response.data;
        if(allData.status){
            downloadAsiListingExcelReport(allData.data,dslNo,yearName)
        }else{
          toast.error(`Data is not found for  this DSL ${dslNo}`, messages.COLOR_RED);
        }

      } catch (error) {
        console.error(error);
        toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
      showLoading(false);
    }
 }


  return (
    <>
    <GlobalLoading />
    <ToastContainer />
    <div className="container-fluid py-3">
      <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="row align-items-center">
          <h4 className="page_heading">
          <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.LISTING_REPORT : asiTitle.en.LISTING_REPORT }} />
         </h4>
           <div className="row align-items-center">

           <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label className="fw-bold h6">
                {storedLanguage === 'hi' ? asiInputTitle.hi.DSL_NO : asiInputTitle.en.DSL_NO}
              </label>
                   <input 
                    type="text"
                    className="form-control"
                    name="dslNo"
                    maxLength="6"
                    value={dslNo}
                    onChange={handleDropdownChange}
                   />
              </div>


              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label className="fw-bold h6">
                 {storedLanguage === 'hi' ? asiInputTitle.hi.SURVEY_YAER : asiInputTitle.en.SURVEY_YAER}
                  </label>
                  <select
                  name="yearName"
                  className="form-select"
                  onChange={handleDropdownChange}
                  value={yearName}
                 >
                  <option value="" disabled>
                    Select Year
                  </option>
                    {year
                      .sort((a, b) => b - a) 
                      .map((yearName, index) => (
                        <option key={index} value={yearName}>
                          {yearName}-{(parseInt(yearName) + 1).toString().slice(2)}
                        </option>
                    ))}
                </select>
              </div>

              
               <div className="col-xl-2 col-lg-12 mb-3">
                <label className="w-100 d-none d-sm-block">&nbsp;</label>
                <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
   </>
  )
}

export default ListingReport